// import React from 'react'

// const HeroSection = () => {
//     return (
//         <>
//             <section id='Work' className="md:px-20 xl:px-32 text-center text-surface lg:text-left py-14 md:py-24">
//                 <div className="container mx-auto">
//                     <h1 className='text-dark dark:text-tx-col text-3xl font-medium md:text-6xl lg:text-7xl xl:font-[300] xl:text-[80px]'>FRONTEND</h1>
//                     {/* <h1 className='text-dark dark:text-tx-col text-5xl font-semibold md:text-8xl lg:text-9xl xl:font-[700] xl:text-[215px] leading-none'>DEVELOPER</h1> */}
//                     <h3 className='moonb text-dark dark:text-tx-col text-5xl md:text-8xl lg:text-9xl xl:text-[200px] leading-none'>DEVELOPER</h3>
//                 </div>
//             </section>
//         </>
//     )
// }

// export default HeroSection

import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import React, { useRef } from 'react'

export const Herosection = () => {
    // 1. Refs for the main elements
    const sectionRef = useRef(null);          // Sectionref for Gsap selector
    const frontendRef = useRef(null);
    const developerBgRef = useRef(null);      // Solid DEVELOPER text
    const developerBorderRef = useRef(null);  // Bordered DEVELOPER text (new animation target)

    // 2. Refs for the central animation piece
    const mainIconContainerRef = useRef(null); // The dark center circle wrapper
    const parentCircleRef = useRef(null);      // The div containing all the small tech icons (Target for rotation)
    // Note: The outer green container is targeted via its class '.bg-y-col' for simplicity

    useGSAP(() => {
        // Create a dedicated timeline for the Hero Section entrance
        const heroTl = gsap.timeline({
            defaults: { ease: "power3.out" },
            // Delay start until the Header animation (approx. 1.5s) is likely finished.
            delay: 1
        });

        // --- 1. Text Entrance Animation ---

        // FRONTEND slides down and fades in (starting the timeline)
        heroTl.from(frontendRef.current, {
            y: -50,
            opacity: 0,
            filter: "blur(8px)",
            duration: 1.0,
        }, 0)

            // DEVELOPER (Background Solid Text) slides up and fades in
            .from(developerBgRef.current, {
                y: 50,
                opacity: 0,
                filter: "blur(8px)",
                duration: 1.0,
            }, "<0.3")

            // 🌟 CHANGE 1: Unique animation for the Bordered DEVELOPER text
            // Instead of a simple scale, let's make it appear with a slight rotation and pop
            .from(developerBorderRef.current, {
                rotationX: 90, // Rotate on the X-axis (flips open)
                y: 10,
                opacity: 0,
                duration: 0.8,
                ease: "power2.out",
                transformOrigin: "top center" // Ensures it flips from the top edge
            }, "-=0.2") // Starts 0.2s *before* the solid text animation ends (overlap)


            // --- 2. Icon & Circle Entrance Animation ---

            // Animate the main dark circle (scales up from the center)
            .from(mainIconContainerRef.current, {
                scale: 0.5,
                opacity: 0,
                duration: 1.2,
                ease: "elastic.out(1, 0.5)",
            }, "-=0.4")

            // Animate the outer green/yellow container (fades in slightly later)
            .from(gsap.utils.toArray(".bg-y-col"), { // Targeting both elements with the bg-y-col class
                opacity: 0,
                y: 30,
                duration: 1.0,
            }, "<0.2") // Starts 0.2s after the main dark circle began

            // --- 3. Tech Icon Stagger Entrance ---

            // Stagger the small tech icons (HTML, CSS, JS, etc.) as they appear
            .from(gsap.utils.toArray(".circle"), {
                opacity: 0,
                // scale: 0,
                duration: 0.4,
                x: 0,
                y: 0,
                filter: "blur(12px)",
                stagger: 0.1,
                ease: "back.out(1.7)",
            }, ">-0.4"); // Starts 0.4s after the main dark circle entrance is complete

    }, { scope: sectionRef });

    return (
        <section id='work' ref={sectionRef} className="md:px-20 xl:px-32 text-center text-surface lg:text-left pt-14 md:pt-16">
            <div className='relative w-full text-center lg:text-left'>
                <h1 className="uppercase flex flex-col">
                    <span ref={frontendRef} className='font-moon text-dark dark:text-tx-col text-3xl font-medium sm:text-5xl md:text-6xl lg:text-7xl xl:font-[300] xl:text-[80px]'>Frontend </span>
                    <span className='flex justify-center lg:justify-start'>
                        <span ref={developerBgRef} className='font-moonb text-dark dark:text-tx-col text-5xl sm:text-7xl md:text-8xl lg:text-9xl xl:text-[200px] leading-none'>Developer</span>
                        <span aria-hidden="true" ref={developerBorderRef} className='font-moonb text-transparent text-5xl sm:text-7xl md:text-8xl lg:text-9xl xl:text-[200px] leading-none bordered-text absolute z-10'>Developer</span>
                    </span>
                </h1>
            </div>
            {/*  **For mini animation section**
            <div className='flex items-center justify-center pt-0 -mt-[34px] sm:-mt-3 md:mt-0 md:pt-14 lg:pt-16 xl:pt-24 relative scale-[.4] sm:scale-50 md:scale-75 lg:scale-[.85] xl:scale-100'>
                <div className="bg-y-col h-64 min-w-[473px] rounded-b-full relative">
                    <div className="bg-y-col h-10 min-w-[473px] rounded-t-[50px] absolute -top-[39px]"></div>
                </div>
                <div className="absolute h-[366px] min-w-[366px] bg-[#2d302d] rounded-full -top-40 sm:-top-40 md:-top-28 lg:-top-24 xl:-top-16 flex justify-center items-center">
             */}
            <div className='flex items-center justify-center -mt-5 sm:mt-0 pt-0 sm:pt-5 md:pt-14 lg:pt-16 xl:pt-24 relative scale-[.45] sm:scale-[.6] md:scale-75 lg:scale-[.85] xl:scale-100'>
                <div className="bg-y-col h-64 min-w-[473px] rounded-b-full relative">
                    <div className="bg-y-col h-10 min-w-[473px] rounded-t-[50px] absolute -top-[39px]"></div>
                </div>
                <div ref={mainIconContainerRef} className="shadow-animshadow absolute h-[366px] min-w-[366px] bg-[#2d302d] rounded-full -top-40 sm:-top-36 md:-top-28 lg:-top-24 xl:-top-16 flex justify-center items-center">
                    <div id="parent-circle" ref={parentCircleRef}>
                        <div className="circle html">
                            <div className='min-w-[70px] md:min-w-[61px] bg-white rounded-lg p-1 absolute shadow-md shadow-[#ffffff50]'>
                                <svg className='dark:text-tx-col mx-auto'
                                    viewBox="0 0 24 24"
                                    fill="#f16529"
                                >
                                    <path d="M13.1 3.5l.7 1.1.7-1.1V5h1V2h-1l-.7 1.1-.6-1.1h-1.1v3h1zM18.4 5V4H17V2h-1v3zM9.8 5h1V3h.9V2H8.9v1h.9zM6.6 4h.9v1h1V2h-1v1h-.9V2h-1v3h1zM5 6l1.2 14.4L12 22l5.8-1.6L19 6H5zm11.3 4.6H9.5l.2 1.8h6.4l-.5 5.5-3.6 1-3.6-1-.3-2.9h1.8l.1 1.5 2 .5 2-.5.2-2.3H8l-.5-5.3h9l-.2 1.7z" />
                                </svg>
                            </div>
                        </div>
                        <div className="circle css">
                            <div className='min-w-[70px] md:min-w-[61px] bg-white rounded-lg p-1.5 absolute shadow-md shadow-[#ffffff50]'>
                                <svg className='dark:text-tx-col mx-auto'
                                    viewBox="0 0 24 24"
                                    fill="#1572b6"
                                >
                                    <path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.565-2.438L1.5 0zm17.09 4.413L5.41 4.41l.213 2.622 10.125.002-.255 2.716h-6.64l.24 2.573h6.182l-.366 3.523-2.91.804-2.956-.81-.188-2.11h-2.61l.29 3.855L12 19.288l5.373-1.53L18.59 4.414z" />
                                </svg>
                            </div>
                        </div>
                        <div className="circle tailwind">
                            <div className='min-w-[70px] md:min-w-[61px] bg-white rounded-lg p-1 absolute shadow-md shadow-[#ffffff50]'>
                                <svg className='dark:text-tx-col mx-auto'
                                    viewBox="0 0 24 24"
                                    fill="#38bdf8"
                                >
                                    <path d="M12.001 4.8c-3.2 0-5.2 1.6-6 4.8 1.2-1.6 2.6-2.2 4.2-1.8.913.228 1.565.89 2.288 1.624C13.666 10.618 15.027 12 18.001 12c3.2 0 5.2-1.6 6-4.8-1.2 1.6-2.6 2.2-4.2 1.8-.913-.228-1.565-.89-2.288-1.624C16.337 6.182 14.976 4.8 12.001 4.8zm-6 7.2c-3.2 0-5.2 1.6-6 4.8 1.2-1.6 2.6-2.2 4.2-1.8.913.228 1.565.89 2.288 1.624 1.177 1.194 2.538 2.576 5.512 2.576 3.2 0 5.2-1.6 6-4.8-1.2 1.6-2.6 2.2-4.2 1.8-.913-.228-1.565-.89-2.288-1.624C10.337 13.382 8.976 12 6.001 12z" />
                                </svg>
                            </div>
                        </div>
                        <div className="circle js">
                            <div className='min-w-[70px] md:min-w-[61px] bg-white rounded-lg p-1.5 absolute shadow-md shadow-[#ffffff50]'>
                                <svg className='dark:text-tx-col mx-auto rounded-[4px]'
                                    viewBox="0 0 24 24"
                                    fill="#f7df1e"
                                >
                                    <path d="M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z" />
                                </svg>
                            </div>
                        </div>
                        <div className="circle react">
                            <div className='min-w-[70px] md:min-w-[61px] bg-white rounded-lg p-1 absolute shadow-md shadow-[#ffffff50]'>
                                <svg className='dark:text-tx-col mx-auto'
                                    viewBox="0 0 24 24"
                                    fill="#3765af"
                                >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M14.448 16.24a21.877 21.877 0 01-1.747 2.175c1.672 1.623 3.228 2.383 4.09 1.884.864-.498.983-2.225.414-4.484-.853.19-1.78.334-2.757.425zm-1.31.087a27.512 27.512 0 01-2.276 0c.377.492.758.948 1.138 1.364.38-.416.76-.872 1.138-1.364zm5.04-7.894c2.665.764 4.405 2.034 4.405 3.567 0 1.533-1.74 2.803-4.405 3.567.67 2.69.441 4.832-.886 5.598-1.328.767-3.298-.105-5.292-2.03-1.994 1.925-3.964 2.797-5.292 2.03-1.327-.766-1.557-2.908-.886-5.598-2.665-.764-4.405-2.034-4.405-3.567 0-1.533 1.74-2.803 4.405-3.567-.67-2.69-.441-4.832.886-5.598 1.328-.767 3.298.105 5.292 2.03 1.994-1.925 3.964-2.797 5.292-2.03 1.327.766 1.557 2.908.886 5.598zm-.973-.248c.57-2.26.45-3.986-.413-4.484-.863-.499-2.419.261-4.09 1.884a22.049 22.049 0 011.746 2.175c.978.09 1.904.234 2.757.425zm-10.41 7.63c-.57 2.26-.45 3.986.413 4.484.863.499 2.419-.261 4.09-1.884a21.877 21.877 0 01-1.746-2.175 21.877 21.877 0 01-2.757-.425zm4.067-8.142a27.512 27.512 0 012.276 0A20.523 20.523 0 0012 6.31c-.38.416-.76.872-1.138 1.364zm-1.31.087A21.877 21.877 0 0111.3 5.585C9.627 3.962 8.07 3.202 7.209 3.701c-.864.498-.983 2.225-.414 4.484.853-.19 1.78-.334 2.757-.425zm4.342 7.52A25.368 25.368 0 0015.787 12a25.368 25.368 0 00-1.893-3.28 25.368 25.368 0 00-3.788 0A25.368 25.368 0 008.213 12a25.368 25.368 0 001.893 3.28 25.368 25.368 0 003.788 0zm1.284-.131c.615-.08 1.2-.183 1.75-.304a20.523 20.523 0 00-.612-1.667 27.512 27.512 0 01-1.138 1.97zM8.822 8.85c-.615.08-1.2.183-1.75.304.17.536.374 1.094.612 1.667a27.512 27.512 0 011.138-1.97zm-1.75 5.994c.55.121 1.135.223 1.75.304a27.512 27.512 0 01-1.138-1.97 20.42 20.42 0 00-.612 1.666zm-.978-.245c.261-.834.6-1.708 1.01-2.6a22.002 22.002 0 01-1.01-2.6c-2.242.637-3.677 1.604-3.677 2.6s1.435 1.963 3.677 2.6zm10.834-5.445a20.808 20.808 0 00-1.75-.304 27.511 27.511 0 011.138 1.97c.238-.572.442-1.13.612-1.666zm.978.245c-.261.834-.6 1.708-1.01 2.6.41.892.749 1.766 1.01 2.6 2.242-.637 3.677-1.604 3.677-2.6s-1.435-1.963-3.677-2.6zM12 13.88a1.88 1.88 0 110-3.76 1.88 1.88 0 010 3.76z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}